'use strict';

import df from 'deep-freeze';

import { findById } from '@/../universal/util';


export default df({
    branches: {
        pageName: 'pobocky',
        nu: {
            inv: {
                companyName: '',

                street: '',
                city: '',
                zip: '',
                ico: '',
                dic: '',

                orZapis: '',
                bank: '',
                swift: '',
                iban: '',
            },
            loc: {
                name: '',

                street: '',
                city: '',
                zip: '',
                email: '',
                phone: '',

                note: '',
            },
        },
    },
    cases: {
        pageName: 'cases',
        nu: {
            vehicleRef: null,
            clientRef: null,
            ownerRef: null,
            driverRefs: [],
            drivers: [],
            guarantorRef: null,

            from: null,
            to: null,
            isInternal: false,

            allowAbroad: false,
            zpusobPlatby: 'cash',
            typPujcovneho: 'daily',
            deposit: null,
            price: null,
            kmLimit: null,
            totalKmLimit: null,
            pricePerExtraKm: null,

            photosOut: [],
            photosIn: [],

            contract: {},
            protocolOut: {},
            protocolIn: {},

            amendments: [],
        },
        fields: {
            zpusobPlatby: {
                options: [
                    'cash',
                    'transfer',
                ],
            },
            typPujcovneho: {
                options: [
                    'daily',
                    'monthly',
                ],
            },
        },
        refs: {
            vehicleRef: 'vehicles',
            clientRef: 'clients',
            ownerRef: 'users',
            driverRefs: {
                collName: 'persons',
                fieldPath: 'drivers',
                recipe: (refs, items) => refs.map(ref => findById(items, ref)),
            },
            guarantorRef: 'persons',
            'contract.signedByRef': 'persons',
            'protocolOut.signedByRef': 'persons',
            'protocolIn.signedByRef': 'persons',
            'amendments.signedByRef': {
                collName: 'persons',
                subItemsPrefix: 'amendments',
            },
        },
        extraFetch: {
            detail: ['branches', 'intervalSets', 'vehicleCategories'],
        },
    },
    claims: {
        pageName: 'pojistneUdalosti',
        refs: {
            vehicleRef: 'vehicles',
            personRef: 'persons',
            caseRef: 'cases',
            driverRef: 'persons',
            'case.clientRef': 'clients',
            resolvedByRef: 'users',
        },
        extraFetch: {
            master: ['clients'],
        },
    },
    clients: {
        pageName: 'klienti',
        nu: {
            personRef: 0,
            person: {
                title: '',
                firstName: '',
                lastName: '',

                street: '',
                city: '',
                zip: '',
                email: '',
                phone: '',

                birthDate: null,
                cisloOp: '',
                scanOp: [],
                cisloRp: '',
                platnostRp: null,
                scanRp: [],
                cisloPasu: '',
                scanPasu: [],
            },

            companyName: '',

            street: '',
            city: '',
            zip: '',
            email: '',
            phone: '',
            ico: '',
            dic: '',

            assist: false,
            rsFrom: null,
            rsTo: null,
            orZapis: '',
            note: '',

            driverRefs: [],
            contactPersonRefs: [],
        },
        refs: {
            personRef: {
                collName: 'persons',
                isEmbedded: true,
            },
            driverRefs: {
                collName: 'persons',
                fieldPath: 'drivers',
                recipe: (refs, items) => refs.map(ref => findById(items, ref)),
            },
            contactPersonRefs: {
                collName: 'persons',
                fieldPath: 'contactPersons',
                recipe: (refs, items) => refs.map(ref => ({ ...findById(items, ref.id), ...ref })),
                refFields: {
                    position: 'text',
                },
            },
        },
        extraFetch: {
            detail: ['cases', 'vehicles'],
        },
    },
    enums: {
        pageName: 'pneumatiky',
    },
    insurers: {
        pageName: 'pojistovny',
        nu: {
            name: '',
        },
    },
    intervalSets: {
        pageName: 'rastry',
        nu: {
            name: '',
            values: [],
        },
    },
    persons: {
        pageName: 'osoby',
        nu: {
            title: '',
            firstName: '',
            lastName: '',

            street: '',
            city: '',
            zip: '',
            email: '',
            phone: '',

            birthDate: null,
            cisloOp: '',
            scanOp: [],
            cisloRp: '',
            platnostRp: null,
            scanRp: [],
            cisloPasu: '',
            scanPasu: [],
        },
        extraFetch: {
            master: ['clients'],
            detail: ['clients'],
        },
    },
    users: {
        pageName: 'uzivatele',
        nu: {
            branchRef: null,

            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            password: '',
            role: 'tech',

            signature: [],
        },
        fields: {
            role: {
                options: [
                    'tech',
                    'manager',
                    'admin',
                ],
            },
        },
        refs: {
            branchRef: 'branches',
        },
    },
    vehicleCategories: {
        pageName: 'ceniky',
        nu: {
            intervalSetRef: null,

            name: '',
            dailyPrices: [],
            monthlyPrice: null,
            dailyKmLimit: null,
            monthlyKmLimit: null,
            pricePerExtraKm: null,
            serviceDays: null,
        },
        refs: {
            intervalSetRef: 'intervalSets',
        },
    },
    vehicles: {
        pageName: 'vozidla',
        fields: {
            gear: {
                options: [
                    'manual',
                    'auto',
                ],
            },
            fuelType: {
                options: [
                    'gas',
                    'diesel',
                    'cng',
                    'electric',
                    'cngAndGas',
                ],
            },
            tyreType: {
                options: [
                    'winter',
                    'summer',
                    'universal',
                ],
            },
            spareType: {
                options: [
                    'fullSize',
                    'temporary',
                    'sealantKit',
                ],
            },
            serviceBook: {
                options: [
                    'electronic',
                    'paper',
                    'none',
                ],
            },
        },
        refs: {
            categoryRef: 'vehicleCategories',
            branchRef: 'branches',
            'carIns.insurerRef': {
                collName: 'insurers',
                subItemsPrefix: 'carIns',
            },
            'accIns.insurerRef': {
                collName: 'insurers',
                subItemsPrefix: 'accIns',
            },
        },
        subTypes: {
            serviceLog: {
                nu: {
                    date: null,
                    description: '',
                    price: null,
                    scanProtokolu: [],
                },
            },
            carIns: {
                nu: {
                    insurerRef: null,
                    from: null,
                    to: null,
                    price: null,
                    number: '',
                    scanZeleneKarty: [],
                },
            },
            accIns: {
                nu: {
                    insurerRef: null,
                    from: null,
                    to: null,
                    coPayPercentage: null,
                    minCoPay: null,
                    price: null,
                    number: '',
                    scanSmlouvy: [],
                },
            },
            stk: {
                nu: {
                    from: null,
                    to: null,
                    price: null,
                    scanProtokolu: [],
                },
            },
            emise: {
                nu: {
                    from: null,
                    to: null,
                    price: null,
                    scanProtokolu: [],
                },
            },
        },
        extraFetch: {
            master: ['cases'],
            detail: ['enums', 'intervalSets'],
        },
    },
});
